
import Vue from "vue";
export default Vue.extend({
  name: "image-over_content",
  props: {
    image: { type: String, default: "" },
    backgroundColor: { type: String, default: "white" },
    maxwidth: { type: Number, default: 40 },
    text: { default: "", type: String },
    to: { default: "", type: String },
  },
});
